import { render, staticRenderFns } from "./MigracionPagoGestion.vue?vue&type=template&id=05b61145"
import script from "./MigracionPagoGestion.vue?vue&type=script&lang=js"
export * from "./MigracionPagoGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports